/**
 * Created by Pankaj on 18-Sep-2019
 */

import {RomanEmpireParsedGameData} from "../server/data/RomanEmpireParsedGameData";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";

export class REReSpinZeroBetController extends RespinZeroBetController {
    private _nextMode: string;

    constructor() {
        super();
    }

    protected calculateIsTriggered(data: RomanEmpireParsedGameData): boolean {
        this._nextMode = data.nextMode;
        return data.isNextGenieReSpin;
    }

    public shouldShowZeroBetCounter(): boolean {
        if (this._nextMode.indexOf("RESPIN") !== -1) {
            return true;
        }
        return false;
    }
}